export default __webpack_public_path__ + "static/media/buster_klein_74.ad4f6350.jpg";